import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import styles from './NotFound.module.scss';
type Props = {
  item: string;
};
const NotFound = props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props.item) {
    t0 = <Head><title>No {props.item} Found - Factiii.com</title></Head>;
    $[0] = props.item;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image alt="Temporary Outage" width={70} height={70} src="/images/notFound.png" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.item) {
    t2 = props.item.toLowerCase();
    $[3] = props.item;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <p className={styles.heading}>Sorry, there aren't any {t2}s with that name.</p>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props.item) {
    t4 = <p>This {props.item} may have been deleted or banned, or the {props.item}{" "}name is incorrect.</p>;
    $[7] = props.item;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.buttons}><Link href="/"><button>Go Home</button></Link></div>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t0 || $[11] !== t3 || $[12] !== t4) {
    t6 = <div className={styles.main}>{t0}{t1}{t3}{t4}{t5}</div>;
    $[10] = t0;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default NotFound;